import { render, staticRenderFns } from "./WebTabsList.vue?vue&type=template&id=517faf87&scoped=true"
import script from "./WebTabsList.vue?vue&type=script&lang=js"
export * from "./WebTabsList.vue?vue&type=script&lang=js"
import style0 from "./WebTabsList.vue?vue&type=style&index=0&id=517faf87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517faf87",
  null
  
)

export default component.exports